/**
 * Promo popup: shows 1s after a product page loads, once per browsing session.
 * Rendered by sections/sb-promo-popup.liquid, only present in the DOM when the
 * current product has a matching, non-expired block.
 */
(function () {
  'use strict';

  var SESSION_KEY = 'sbPromoPopupDismissed';
  var SHOW_DELAY_MS = 1000;

  var popup = document.getElementById('sb-promo-popup');
  if (!popup) return;

  function dismiss() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      /* sessionStorage unavailable (private mode etc.) — popup just won't persist the dismissal */
    }
    popup.classList.remove('is-visible');
  }

  function wasDismissedThisSession() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  // Docks the popup above sb-sticky-atc on mobile instead of the raw viewport
  // edge. That bar is always in the DOM at its full height (it only animates
  // via transform/opacity, never display:none), so its rendered height is a
  // reliable, always-current offset — no coupling to its own CSS internals.
  function syncStickyAtcOffset() {
    var stickyBar = document.querySelector('.sb-sticky-atc');
    var offset = stickyBar ? stickyBar.getBoundingClientRect().height : 0;
    popup.style.setProperty('--sb-promo-popup-offset', offset + 'px');
  }

  var closeBtn = document.getElementById('sb-promo-popup-close');
  if (closeBtn) closeBtn.addEventListener('click', dismiss);

  var copyBtn = document.getElementById('sb-promo-popup-copy');
  var codeEl = document.getElementById('sb-promo-popup-code');
  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', function () {
      var code = codeEl.textContent.trim();
      var resetLabel = function () {
        copyBtn.textContent = copyBtn.dataset.labelDefault || 'Copy';
        copyBtn.classList.remove('is-copied');
      };
      var showCopied = function () {
        copyBtn.textContent = copyBtn.dataset.labelCopied || 'Copied!';
        copyBtn.classList.add('is-copied');
        setTimeout(resetLabel, 1800);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function () {
          /* clipboard write blocked — leave the code visible for manual copy */
        });
      }
    });
  }

  var buyBtn = document.getElementById('sb-promo-popup-buy');
  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      var mainProduct = document.querySelector('[id^="MainProduct-"]');
      var infoContainer = mainProduct ? mainProduct.querySelector('.product__info-container') : null;
      var scrollTarget = infoContainer || mainProduct;
      if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth' });
      dismiss();
    });
  }

  if (wasDismissedThisSession()) return;

  syncStickyAtcOffset();
  window.addEventListener('resize', syncStickyAtcOffset);

  setTimeout(function () {
    if (wasDismissedThisSession()) return;
    syncStickyAtcOffset();
    popup.classList.add('is-visible');
  }, SHOW_DELAY_MS);
})();
